import { IFormProfile } from 'legacy/lut/classes/models/IFormProfile'
import { useCallback, useEffect, useState } from 'react'

import { Checkbox } from 'core-components/library/checkbox'
import { Input } from 'core-components/library/inputs'
import { IPanelContentProps } from 'core-components/library/list/filterArea'
import { IDataProviderFilter, IFilter, Logic, Operator } from 'core-components/types'

import { INITIAL_CONJUNCTION_FILTER, INITIAL_DISJUNCTION_FILTER } from '../../../../configs'
import { isIDataProviderFilter } from '../../helpers/isIDataProviderFilter'
import { isIFilter } from '../../helpers/isIFilter'

import { SEARCH_FIELDS } from './configs'

export const PanelContent = ({
  filter = INITIAL_CONJUNCTION_FILTER,
  onFilterChange,
}: IPanelContentProps<IFormProfile>) => {
  const [inputValue, setInputValue] = useState<string | number>('')
  const [checkboxFilter, setCheckboxFilter] = useState<IDataProviderFilter | IFilter>()

  const onInputChangeHandler = useCallback((value: string) => {
    setInputValue(value)

    const newOrFilter = INITIAL_DISJUNCTION_FILTER

    newOrFilter.filters = SEARCH_FIELDS.map((field) => ({
      field,
      operator: Operator.CONTAINS,
      value: value,
    }))

    onFilterChange({
      logic: Logic.AND,
      filters: [newOrFilter],
    })
  }, [])

  const onCheckBoxChangeHadler = useCallback(() => {
    if (!checkboxFilter) {
      const newCheckboxFilter: IFilter = {
        field: 'Status',
        operator: Operator.EQUAL,
        value: null,
      }

      onFilterChange({ ...filter, filters: [...filter.filters, newCheckboxFilter] })
      setCheckboxFilter(newCheckboxFilter)
    } else {
      const newFilters = filter.filters.filter((el: any) => !(el.field === 'Status' && !el.value))
      onFilterChange({ ...filter, filters: newFilters })
      setCheckboxFilter(undefined)
    }
  }, [])

  useEffect(() => {
    const newCheckboxFilter = filter.filters.find((el: any) => el.field === 'Status' && !el.value)
    setCheckboxFilter(newCheckboxFilter)
  }, [filter.filters])

  useEffect(() => {
    const disjunctionFilter = filter.filters.find(
      (el) => isIDataProviderFilter(el) && el.logic === Logic.OR
    )

    const filterValue =
      (disjunctionFilter &&
        isIDataProviderFilter(disjunctionFilter) &&
        isIFilter(disjunctionFilter.filters[0]) &&
        disjunctionFilter.filters[0].value) ||
      ''

    const initialValue = Array.isArray(filterValue) ? filterValue.join(', ') : filterValue

    setInputValue(initialValue)
  }, [filter.filters.length])

  useEffect(() => {
    const statusFilter = filter.filters.find((el: any) => el.field === 'Status' && !el.value)
    setCheckboxFilter(statusFilter)
  }, [filter])

  return (
    <div>
      <Input value={inputValue} onChange={onInputChangeHandler} label="Search..." autoFocus />
      <Checkbox
        margin={'md'}
        padding
        label={'Show inactive contacts'}
        checked={!!checkboxFilter}
        onChange={onCheckBoxChangeHadler}
      />
    </div>
  )
}
